import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import Row from 'react-bootstrap/Row';
import { ImInfo } from 'react-icons/im';
import Moment from 'moment';
import DatePicker from '../../components/datepicker/datepicker';
import Button from '../../components/button/button';
import CurrencyInput from '../../components/currencyinput/currencyinput';
import { QUESTIONS, EARLIEST_START_DATE } from '../../constants.jsx';

// eslint-disable-next-line no-unused-vars
import questionscss from './questions.css';
import { resize } from '../../utils/calculate';

const Question1 = props => {
  const {
    question1HelpText,
    incurredDate: [startDate, setStartDate],
    incurredAmount: [amount, setAmount],
    finalPaymentDate: [finalPaymentDate, setFinalPaymentDate],
    onFinish,
    onReset,
  } = { ...props };

  const [startDateErrorMessage, setStartDateErrorMessage] = useState();
  const [finalDateErrorMessage, setFinalDateErrorMessage] = useState();
  const [amountErrorMessage, setAmountErrorMessage] = useState();

  React.useEffect(() => {
    resize();
  });

  const latestDate = new Moment().add(10, 'years').toDate();

  const clearErrorMessages = () => {
    setStartDateErrorMessage('');
    setFinalDateErrorMessage('');
    setAmountErrorMessage('');
  };

  const validateStartDate = newDate => {
    let valid = true;
    setStartDateErrorMessage('');

    if (newDate === null || newDate === undefined) {
      setStartDateErrorMessage('Debt date must be set');
      valid = false;
    }

    if (new Moment(newDate).isAfter(new Moment())) {
      setStartDateErrorMessage('Debt date cannot be greater than todays date');
      valid = false;
    }

    if (new Moment(newDate).isBefore(new Moment(EARLIEST_START_DATE))) {
      setStartDateErrorMessage('Debt date cannot be before 01/01/2007');
      valid = false;
    }

    if (new Moment(newDate).isAfter(new Moment(finalPaymentDate))) {
      setStartDateErrorMessage('Debt date cannot be after final payment date');
      valid = false;
    }

    return valid;
  };

  const validateFinalDate = newDate => {
    let valid = true;
    setFinalDateErrorMessage('');

    if (newDate === null || newDate === undefined) {
      setFinalDateErrorMessage('Final date must be set');
      valid = false;
    }

    if (new Moment(newDate).isAfter(latestDate)) {
      setFinalDateErrorMessage(
        'Final date cannot be greater than ten years from todays date'
      );
      valid = false;
    }

    if (new Moment(newDate).isBefore(new Moment(startDate))) {
      setFinalDateErrorMessage(
        'Final date cannot be before debt incurred date'
      );
      valid = false;
    }

    return valid;
  };

  const validateAmount = newAmount => {
    let valid = true;
    setAmountErrorMessage('');

    if (
      newAmount === null ||
      newAmount === undefined ||
      Number.isNaN(newAmount) ||
      newAmount === ''
    ) {
      setAmountErrorMessage('Amount must be set');
      valid = false;
    }
    if (newAmount === '0.00' || newAmount === 0) {
      setAmountErrorMessage('Amount must be greater than 0');
      valid = false;
    }
    if (newAmount > 10000000) {
      setAmountErrorMessage('Amount cannot be greater than $10,000,000.00');
      valid = false;
    }
    return valid;
  };

  const questionValidation = () => {
    const va = validateAmount(amount);
    const vd = validateStartDate(startDate);
    const vf = validateFinalDate(finalPaymentDate);

    if (va && vd && vf) return true;

    return false;
  };

  const onChangeStartDate = newDate => {
    validateStartDate(newDate);
    setStartDate(newDate);
  };

  const onChangeFinalDate = newDate => {
    validateFinalDate(newDate);
    setFinalPaymentDate(newDate);
  };

  const onAmountChange = newAmount => {
    validateAmount(newAmount);
    setAmount(newAmount);
  };

  const today = new Date();

  return (
    <>
      <h3>
        <span>
          {QUESTIONS.QUESTION1}
          {question1HelpText.length ? (
            <a data-event="click" type="submit" data-tip data-for="tooltip1">
              <ImInfo className="help-text-button" />
            </a>
          ) : null}
        </span>
      </h3>
      {question1HelpText.length ? (
        <ReactTooltip
          globalEventOn="click"
          globalEventOff="click"
          id="tooltip1"
          place="bottom"
          effect="solid"
        >
          <div>{question1HelpText}</div>
        </ReactTooltip>
      ) : null}
      <DatePicker
        date={startDate}
        onDateChange={onChangeStartDate}
        title="Debt incurred date *"
        minDate={EARLIEST_START_DATE}
        maxDate={today}
        errorMessage={startDateErrorMessage}
        id="date-picker-incurred"
        // required
      />

      <CurrencyInput
        title={QUESTIONS.QUESTION1_2}
        maxLength={11}
        onValueChange={onAmountChange}
        value={amount}
        errorMessage={amountErrorMessage}
      />

      <DatePicker
        date={finalPaymentDate}
        onDateChange={onChangeFinalDate}
        title="Final payment date *"
        errorMessage={finalDateErrorMessage}
        maxDate={latestDate}
        id="date-picker-final"
        // required
      />

      <Row className="button-wrapper">
        <div>
          <Button
            title="Reset"
            onClick={() => {
              clearErrorMessages();
              onReset();
            }}
            variant="secondary"
            className="float-right"
          />
        </div>
        <div>
          <Button
            title="Next"
            onClick={() => {
              if (questionValidation()) {
                onFinish({ startDate, finalPaymentDate, amount });
              }
            }}
            variant="primary"
            className="float-right"
          />
        </div>
      </Row>
    </>
  );
};

export default Question1;
